import { ComponentType } from "react";

import { BackgroundAttributeProps } from "@multiweb/reactComponents";
import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { IconCode, IPublicAttributeInfo } from "@multiweb/types/contracts";
import { FlagColor, RecordType } from "@multiweb/types/react";
import { FrameAttributeSharedProps } from "../../types";

/**
 * Properties pro komponentu atributu.
 */
export type AttributeProps = FrameAttributeSharedProps & BackgroundAttributeProps & {
    /** Záznam z modulu dataSource. */
    record?: RecordType;
    /** Konkrétní atribut. */
    dataSourceAttribute?: IDataSourceAttribute;
    /** Obecné informace k danému atributu. */
    dataSourceAttributeInfo?: IPublicAttributeInfo;
    /** Barva pozadí. */
    backgroundAttributeColor?: FlagColor;
    /** Určuje, zda je komponenta vizuálně aktivní a zda s ní lze pracovat. */
    interactive?: boolean;
    /** Určuje, jestli se má atribut vyrenderovat na řádku společně s ostatními atributy. */
    inline?: boolean;
    /** Popisek atributu. */
    title?: string;
    /** Pevná ikona u atributu. */
    iconCode?: IconCode;
};

/**
 * Typ komponenty pro zobrazeni atributu.
 */
export type AttributeComponent<Props extends AttributeProps = AttributeProps> = ComponentType<Props>;

/**
 * Properties pro komponentu placeholder.
 */
export type PlaceholderProps = FrameAttributeSharedProps & {
    /** Určuje index renderovaného atributu. */
    attributeIndex?: number;
    /** Určuje, zda je daný záznam interativní. */
    interactive?: boolean;
    /** Jméno atributu, který určuje jakou barvou se má obarvit pozadí. */
    backgroundAttributeName?: string;
};

/**
 * Typ komponenty pro zobrazeni placeholderu atributu.
 */
export type PlaceholderComponent<Props extends PlaceholderProps = PlaceholderProps> = ComponentType<Props>;
